import type { EditLifecyclePageProps } from "./CreateOrEditLifecyclePage";
import { CreateOrEditLifecyclePage } from "./CreateOrEditLifecyclePage";
export function LifecyclePage({ spaceId, lifecycleId, queryParams, setQueryParams }: EditLifecyclePageProps) {
    return <CreateOrEditLifecyclePage spaceId={spaceId} lifecycleId={lifecycleId} queryParams={queryParams} setQueryParams={setQueryParams}/>;
}
